const GA_ID = 'G-B2CHTCMLM1';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function loadGoogleAnalytics(): void {
  if (document.querySelector(`script[src*="gtag/js?id=${GA_ID}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function initAnalyticsIfConsented(): void {
  if (localStorage.getItem('cookieconsent_status') === 'accepted') {
    loadGoogleAnalytics();
  }
}
